<template>
  <div class="works-component colourslinkhouse">
    <div class="banner"> 
      <img src="../../../assets/img/works/link-house-condo/09-色彩生活-COLOURS- SEMANJA KAJANG -KAJANG/00-hero banner.jpg" alt="">
    </div>
    <div class="border-bottom-1px">
      <div class="container ">
        <p class="playfair playfair-display-sm-400 black text-left m-0">
          色彩生活 | Colours
        </p>
      </div>
    </div>
    <div class="container p-112 works-img border-bottom-1px"> 
      <b-row sm>
        <b-col md="6" sm>
          <img  :src="require('@/assets/img/works/link-house-condo/09-色彩生活-COLOURS- SEMANJA KAJANG -KAJANG/01-landscape-living-01.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(0)" >
         </b-col>
        <b-col md="6" sm>
          <img  :src="require('@/assets/img/works/link-house-condo/09-色彩生活-COLOURS- SEMANJA KAJANG -KAJANG/01-landscape-living-02.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(1)" >
        </b-col> 
      </b-row>
      <b-row sm>
        <b-col md="4" sm>
          <img  :src="require('@/assets/img/works/link-house-condo/09-色彩生活-COLOURS- SEMANJA KAJANG -KAJANG/02-landscape-living-01.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(2)" >
        </b-col>
        <b-col md="4" sm>
          <img  :src="require('@/assets/img/works/link-house-condo/09-色彩生活-COLOURS- SEMANJA KAJANG -KAJANG/02-landscape-living-02.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(3)" >
        </b-col>
        <b-col md="4" sm>
          <img  :src="require('@/assets/img/works/link-house-condo/09-色彩生活-COLOURS- SEMANJA KAJANG -KAJANG/02-landscape-living-03.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(4)" >
        </b-col>
      </b-row>
      <b-row sm>
        <b-col md="4" sm>
          <img  :src="require('@/assets/img/works/link-house-condo/09-色彩生活-COLOURS- SEMANJA KAJANG -KAJANG/03-portrait-living-01.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(5)" >
        </b-col>
        <b-col md="4" sm>
          <img  :src="require('@/assets/img/works/link-house-condo/09-色彩生活-COLOURS- SEMANJA KAJANG -KAJANG/03-portrait-living-02.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(6)" >
        </b-col>
        <b-col md="4" sm>
          <img  :src="require('@/assets/img/works/link-house-condo/09-色彩生活-COLOURS- SEMANJA KAJANG -KAJANG/03-portrait-living-03.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(7)" >
        </b-col>
      </b-row>
      <b-row sm>
        <b-col>
          <img  :src="require('@/assets/img/works/link-house-condo/09-色彩生活-COLOURS- SEMANJA KAJANG -KAJANG/04-full-dry-01.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(8)" >
        </b-col>
      </b-row>
      <b-row sm>
        <b-col md="6" sm>
          <img  :src="require('@/assets/img/works/link-house-condo/09-色彩生活-COLOURS- SEMANJA KAJANG -KAJANG/05-landscape-dry-02.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(9)" >
        </b-col>
        <b-col md="6" sm>
          <img  :src="require('@/assets/img/works/link-house-condo/09-色彩生活-COLOURS- SEMANJA KAJANG -KAJANG/05-landscape-dry-02.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(9)" >
        </b-col> 
      </b-row>
      <b-row sm>
        <b-col>
          <img  :src="require('@/assets/img/works/link-house-condo/09-色彩生活-COLOURS- SEMANJA KAJANG -KAJANG/06-full-wet-01.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(10)" >
        </b-col>
      </b-row> 
      <b-row sm>
        <b-col md="6" sm>
          <img  :src="require('@/assets/img/works/link-house-condo/09-色彩生活-COLOURS- SEMANJA KAJANG -KAJANG/07-landscape-master-01.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(11)" >
        </b-col> 
        <b-col md="6" sm>
          <img  :src="require('@/assets/img/works/link-house-condo/09-色彩生活-COLOURS- SEMANJA KAJANG -KAJANG/07-landscape-master-02.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(12)" >
        </b-col>
      </b-row>
      <b-row sm>
        <b-col md="6" sm>
          <img  :src="require('@/assets/img/works/link-house-condo/09-色彩生活-COLOURS- SEMANJA KAJANG -KAJANG/08-portrait-master-01.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(13)" >
        </b-col>
        <b-col md="6" sm>
          <img  :src="require('@/assets/img/works/link-house-condo/09-色彩生活-COLOURS- SEMANJA KAJANG -KAJANG/08-portrait-master-02.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(14)" >
        </b-col> 
      </b-row>
      <b-row sm>
        <b-col>
          <img  :src="require('@/assets/img/works/link-house-condo/09-色彩生活-COLOURS- SEMANJA KAJANG -KAJANG/09-full-master-01.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(15)" >
        </b-col>
      </b-row> 
      <b-row sm>
        <b-col md="6" sm>
          <img  :src="require('@/assets/img/works/link-house-condo/09-色彩生活-COLOURS- SEMANJA KAJANG -KAJANG/10-portrait-master-01.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(16)" >
        </b-col>
        <b-col md="6" sm>
          <img  :src="require('@/assets/img/works/link-house-condo/09-色彩生活-COLOURS- SEMANJA KAJANG -KAJANG/10-portrait-master-02.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(17)" >
        </b-col> 
      </b-row>
      <b-row sm>
        <b-col>
          <img  :src="require('@/assets/img/works/link-house-condo/09-色彩生活-COLOURS- SEMANJA KAJANG -KAJANG/11-full-kid1-01.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(18)" >
        </b-col>
      </b-row> 
      <b-row sm>
        <b-col md="6" sm>
          <img  :src="require('@/assets/img/works/link-house-condo/09-色彩生活-COLOURS- SEMANJA KAJANG -KAJANG/12-landscape-kid1-01.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(19)" >
        </b-col>
        <b-col md="6" sm>
          <img  :src="require('@/assets/img/works/link-house-condo/09-色彩生活-COLOURS- SEMANJA KAJANG -KAJANG/12-landscape-kid2-02.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(20)" >
        </b-col> 
      </b-row> 
      <b-row sm>
        <b-col md="4" sm>
          <img  :src="require('@/assets/img/works/link-house-condo/09-色彩生活-COLOURS- SEMANJA KAJANG -KAJANG/13-portrait-kid1-01.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(21)" >
        </b-col>
        <b-col md="4" sm>
          <img  :src="require('@/assets/img/works/link-house-condo/09-色彩生活-COLOURS- SEMANJA KAJANG -KAJANG/13-portrait-kid1-02.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(22)" >
        </b-col> 
        <b-col md="4" sm>
          <img  :src="require('@/assets/img/works/link-house-condo/09-色彩生活-COLOURS- SEMANJA KAJANG -KAJANG/13-portrait-kid1-03.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(23)" >
        </b-col> 
      </b-row>  
      <b-row sm>
        <b-col md="6" sm>
          <img  :src="require('@/assets/img/works/link-house-condo/09-色彩生活-COLOURS- SEMANJA KAJANG -KAJANG/14-portrait-kid2-01.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(24)" >
        </b-col>
        <b-col md="6" sm>
          <img  :src="require('@/assets/img/works/link-house-condo/09-色彩生活-COLOURS- SEMANJA KAJANG -KAJANG/14-portrait-kid2-02.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(25)" >
        </b-col> 
      </b-row>  
      <b-row sm>
        <b-col>
          <img  :src="require('@/assets/img/works/link-house-condo/09-色彩生活-COLOURS- SEMANJA KAJANG -KAJANG/15-full-facade-01.jpg')"  alt="" class="cursor-pointer" @click="showLightbox(26)" >
        </b-col>
      </b-row>  
    </div>
    <div class="container p-112 works-img">
      <b-row >
        <b-col md="4" class="pb-24"> 
          <b-row class="flex-center">
            <b-col cols="3" to="Jade"  tag="router-link"><img class="icon-expand cursor-pointer" src="../../../assets/img/icon/expand_circle_left.svg"></b-col>
            <b-col cols="9" class="text-right">
              <p class="inter inter-body-md-600 black  p-0">PREVIOUS PROJECT</p>
              <p class="playfair playfair-title-lg-400 black p-0">青禾 | Jade</p>
              <p class="inter inter-body-md-400 black p-0">Landmark Residence | Kajang</p>
            </b-col> 
          </b-row>
        </b-col>
        <b-col md="4" sm> 
        </b-col>
        <b-col md="4" sm> 
          <b-row class="flex-center">
            <b-col cols="9" class="text-left">
              <p class="inter inter-body-md-600 black  p-0">NEXT PROJECT</p>
              <p class="playfair playfair-title-lg-400 black p-0">石 | Rock</p>
              <p class="inter inter-body-md-400 black p-0">KM1 | Bukit Jalil</p>
            </b-col>
            <b-col cols="3"  to="Rock"  tag="router-link"><img class="icon-expand cursor-pointer" src="../../../assets/img/icon/expand_circle_right.svg" alt=""></b-col>
          </b-row>
          
        </b-col>
      </b-row>
    </div>
    <GlobalLightbox
      :visible.sync="lightboxVisible"
      :images="resolvedImages"
      :index="currentIndex"
    />
  </div>

</template>

<script>
import GlobalLightbox from "@/components/GlobalLightbox.vue";

export default {
  name: 'coloursLinkHouse',
  components: { GlobalLightbox },

  data() {
    return { 
      basePath: "@/assets/img/works/link-house-condo/09-色彩生活-COLOURS- SEMANJA KAJANG -KAJANG/",
      images: [  
        "01-landscape-living-01.jpg",
        "01-landscape-living-02.jpg",
        "02-landscape-living-01.jpg",
        "02-landscape-living-02.jpg",
        "02-landscape-living-03.jpg",
        "03-portrait-living-01.jpg",
        "03-portrait-living-02.jpg",
        "03-portrait-living-03.jpg",
        "04-full-dry-01.jpg",
        "05-landscape-dry-02.jpg",
        "06-full-wet-01.jpg",
        "07-landscape-master-01.jpg",
        "07-landscape-master-02.jpg",
        "08-portrait-master-01.jpg",
        "08-portrait-master-02.jpg",
        "09-full-master-01.jpg",
        "10-portrait-master-01.jpg",
        "10-portrait-master-02.jpg",
        "11-full-kid1-01.jpg",
        "12-landscape-kid1-01.jpg",
        "12-landscape-kid2-02.jpg",
        "13-portrait-kid1-01.jpg",
        "13-portrait-kid1-02.jpg",
        "13-portrait-kid1-03.jpg",
        "14-portrait-kid2-01.jpg",
        "14-portrait-kid2-02.jpg",
        "15-full-facade-01.jpg",

      ],
      lightboxVisible: false,
      currentIndex: 0
    }
  },
  methods: { 
    showLightbox(index) {
      this.currentIndex = index;
      this.lightboxVisible = true;
    },
  },
computed: {
    resolvedImages() {
     return this.images.map(img => 
      require(`@/assets/img/works/link-house-condo/09-色彩生活-COLOURS- SEMANJA KAJANG -KAJANG/${img}`)
    );
  }
  },
}
</script>

<style>
 
.colourslinkhouse{
  background-color: #D5DAD7  !important;
}
.banner img, .works-img img{
  width: 100%;
}
.works-img img{
  padding-bottom: 24px;
}
.colourslinkhouse p {
  padding: 24px 0;  
}
.p-112{
  padding: 112px 0 88px;
}
.works-component .amalfi-coast-title {
  padding-bottom: 4rem;
}

.letter-spacing {
  letter-spacing: 0.5em;
  padding-bottom: 56px
}
img.icon-expand{
  width: auto;
}

@media (max-width: 576px) { 
}
</style>